import { z } from 'zod'

const schema = z.object({
  NEXT_PUBLIC_APP_URL: z.string().url().optional(),
  NEXT_PUBLIC_APP_NAME: z.string().min(1).default('Nexline Global'),
  NEXT_PUBLIC_APP_DESCRIPTION: z.string().min(1).default(
    'Web, SaaS, mobile, backend, and AI automation solutions by Nexline Global Pvt. Ltd.',
  ),
  NEXT_PUBLIC_APP_ENV: z.enum(['development', 'preview', 'staging', 'production', 'test']).optional(),
  NEXT_PUBLIC_SITE_NAME: z.string().min(1).optional(),
  NEXT_PUBLIC_SITE_DESCRIPTION: z.string().min(1).optional(),
  NEXT_PUBLIC_SITE_URL: z.string().url().optional(),
  NEXT_PUBLIC_SITE_LEGAL_NAME: z.string().min(1).optional(),
  NEXT_PUBLIC_SITE_TAGLINE: z.string().min(1).optional(),
  NEXT_PUBLIC_SITE_LOCALE: z.string().min(1).optional(),
  NEXT_PUBLIC_SITE_SUPPORT_EMAIL: z.string().email().optional(),
  NEXT_PUBLIC_SITE_TWITTER: z.string().min(1).optional(),
  NEXT_PUBLIC_SITE_GITHUB: z.string().min(1).optional(),
  NEXT_PUBLIC_SITE_LINKEDIN: z.string().min(1).optional(),
  NEXT_PUBLIC_SITE_X: z.string().min(1).optional(),
  NEXT_PUBLIC_SITE_OVERRIDES: z.string().optional(),
  NEXT_PUBLIC_SENTRY_DSN: z.string().url().optional(),
})

const parsed = schema.safeParse(process.env)

if (!parsed.success) {
  const issues = parsed.error.issues.map(issue => `  - ${issue.path.join('.')}: ${issue.message}`).join('\n')
  throw new Error(`Invalid public environment variables:\n${issues}`)
}

export const publicEnv = parsed.data
